import { useAppSelector } from "hooks";
import { Navigate, Outlet } from "react-router-dom";

interface INavigate {
  navigate: string;
}

const ProtectedAdminRoute = ({ navigate }: INavigate) => {
  // const {isLoggedIn} = useAppSelector((state) => state.auth);
  // const {isAdmin} = useAppSelector ((state)=> state.auth.user.user.isAdmin)

  const { isLoggedIn, isAdmin } = useAppSelector((state) => state.auth);
  // console.log(useAppSelector((state) => state.auth));
  console.log(isLoggedIn, isAdmin);
  return isLoggedIn && isAdmin ? <Outlet /> : <Navigate to={navigate} replace />;
};

export default ProtectedAdminRoute;
